import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';
const ROMAN = ['I', 'II', 'III'];
const IMGS = [IMAGES.cheesecake, IMAGES.heroFeature, IMAGES.box];
export function Product() {
  const {
    t
  } = useLanguage();
  return <section id="product" className="py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-195">
      <div className="max-w-[1300px] mx-auto px-8 lg:px-14" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end" data-id="element-197">
          <div className="lg:col-span-7" data-id="element-198">
            <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-199">
              <span className="w-10 h-px bg-caramel/40" data-id="element-200" />
              {t.product.eyebrow}
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-201">
              {t.product.title1}
              <br data-id="element-202" />
              <span className="italic font-extralight" data-id="element-203">{t.product.title2}</span>
            </h2>
          </div>
          <div className="lg:col-span-5" data-id="element-204">
            <p className="text-cream/60 leading-[1.8] text-[15px] max-w-md" data-id="element-205">
              {t.product.intro}
            </p>
          </div>
        </motion.div>

        <div className="mt-28 lg:mt-36 grid md:grid-cols-3 gap-y-20 md:gap-y-0 md:gap-x-12 lg:gap-x-16" data-id="element-206">
          {t.product.features.map((f, i) => <motion.article key={f.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 1,
          delay: i * 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative group text-center" data-id="element-207">
              <span aria-hidden className="absolute left-1/2 -translate-x-1/2 -top-10 font-serif italic font-extralight text-cream/[0.06] select-none pointer-events-none leading-none" style={{
            fontSize: 'clamp(140px, 18vw, 220px)'
          }} data-id="element-208">
                {ROMAN[i]}
              </span>

              <div className="relative inline-block" data-id="element-209">
                <div className="absolute -inset-2 rounded-full ring-1 ring-cream/10" aria-hidden data-id="element-210" />
                <div className="relative w-40 h-40 lg:w-48 lg:h-48 rounded-full overflow-hidden ring-1 ring-cream/15 transition-transform duration-[1400ms] group-hover:scale-[1.04]" style={{
              boxShadow: '0 24px 50px -20px rgba(0,0,0,0.6), 0 0 0 1px rgba(247,240,232,0.05)'
            }} data-id="element-211">
                  <img src={IMGS[i]} alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-212" />
                  <div className="absolute inset-0 pointer-events-none" style={{
                background: 'radial-gradient(circle at 35% 30%, rgba(247,240,232,0.15), transparent 55%)'
              }} data-id="element-213" />
                </div>
              </div>

              <div className="relative mt-10 flex items-center justify-center gap-3 text-caramel" data-id="element-214">
                <span className="w-1 h-1 rotate-45 bg-caramel/70" aria-hidden data-id="element-215" />
                <span className="font-serif italic text-[13px] tracking-[0.05em]" data-id="element-216">
                  {f.eyebrow}
                </span>
                <span className="w-1 h-1 rotate-45 bg-caramel/70" aria-hidden data-id="element-217" />
              </div>

              <h3 className="relative mt-5 font-serif text-3xl lg:text-[34px] text-cream font-light tracking-[-0.01em] leading-[1.05]" data-id="element-218">
                {f.title}
              </h3>

              <p className="relative mt-6 text-cream/55 leading-[1.85] text-[14px] max-w-[280px] mx-auto" data-id="element-219">
                {f.copy}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}